import appConfig from '~/config/app'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function usePriceList(): string {
  const isSmallScreen = useCheckBreakpoint({ lt: Breakpoint.LG })
  let path = 'mentor-on-demand/home/pricelist/'

  if (isSmallScreen) {
    path += 'wave-grad-bg-mobile.svg'
  } else {
    path += 'wave-grad-bg-desktop.svg'
  }

  return `${appConfig.assetsCdnUrl}/${path}`
}
